import * as React from 'react';

function KeyboardBackspace(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.041 17.6H8.216L4.158 12l4.058-5.6h11.825v11.2zm.73-12.6H7.835a.739.739 0 00-.599.3l-4.565 6.3a.677.677 0 000 .8l4.565 6.3c.136.188.36.3.599.3H20.77c.403 0 .73-.314.73-.7V5.7c0-.386-.327-.7-.73-.7zm-10.36 9.77a.743.743 0 00.516.205.743.743 0 00.515-.205l1.854-1.78 1.855 1.78a.743.743 0 00.515.205.743.743 0 00.516-.205.68.68 0 000-.99L14.327 12l1.855-1.78a.68.68 0 000-.99.75.75 0 00-1.031 0l-1.855 1.78-1.854-1.78a.75.75 0 00-1.03 0 .68.68 0 000 .99L12.264 12l-1.854 1.78a.68.68 0 000 .99z"
        fill="currentColor"
      />
    </svg>
  );
}

export default KeyboardBackspace;
